import { render, staticRenderFns } from "./aiAnalytics.vue?vue&type=template&id=fa83b1f6&scoped=true"
import script from "./aiAnalytics.vue?vue&type=script&lang=js"
export * from "./aiAnalytics.vue?vue&type=script&lang=js"
import style0 from "./aiAnalytics.vue?vue&type=style&index=0&id=fa83b1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa83b1f6",
  null
  
)

export default component.exports